import { render, staticRenderFns } from "./ImageInfo.vue?vue&type=template&id=2e46364b&scoped=true&"
import script from "./ImageInfo.vue?vue&type=script&lang=js&"
export * from "./ImageInfo.vue?vue&type=script&lang=js&"
import style0 from "./ImageInfo.vue?vue&type=style&index=0&id=2e46364b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e46364b",
  null
  
)

export default component.exports